// @flow

import React from 'react';
import glamorous from 'glamorous';
import Rows from '../../components/layout/Rows';

const req = require.context('../../images/jackpotSlots/svgs', false, /.*\.svg$/);
const comps = [
  { name: 'WIN 10', icon: req('./aleague.svg') },
  { name: 'WIN 50', icon: req('./odi.svg') },
  { name: 'WIN 100', icon: req('./nba.svg') },
  { name: 'WIN 500', icon: req('./nrl.svg') },
  { name: 'JACKPOT', icon: req('./chest.svg') },
];

const LegendWrapper = glamorous.div(
  {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // minHeight: 190,
  },
  ({ theme }) => ({
    padding: theme.spacing.small,
    paddingBottom: 0,
  }),
);

const LegendText = glamorous.div(({ theme }) => ({
  textAlign: 'center',
  fontSize: theme.fontSize.default,
}));

const IconText = glamorous.span(({ theme }) => ({
  fontSize: theme.fontSize.small,
  textTransform: 'uppercase',
  paddingLeft: theme.spacing.xxsmall,
}));

const RowGroup = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
});

const Container = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const StyledRows = glamorous(Rows)({
  flexGrow: 1,
  maxWidth: 800,
});

function JackpotLegend() {
  return (
    <LegendWrapper>
      <LegendText>Match 3 to WIN!</LegendText>
      <RowGroup>
        <StyledRows desktop={4} mobile={3}>
          {comps.map(comp => (
            <Container key={comp.name}>
              <img alt="" src={comp.icon} width={40} height={40} />
              <IconText>{comp.name}</IconText>
            </Container>
          ))}
        </StyledRows>
      </RowGroup>
    </LegendWrapper>
  );
}

export default JackpotLegend;
